import React from "react";
import PrintLinks from "./PrintLinks";
import PrintP2PLinks from "./PrintP2PLinks";
import PrintLTLinks from "./PrintLTLinks";
import PrintLeasingLinks from "./PrintLeasingLinks";
import Paper from '@material-ui/core/Paper';

export default (props) => (
    <Paper className="common-paper" style={{ marginTop: 20, marginBottom: 20 }}>
        <div className="common-form wide-column">
        {
            ({
                "PTS_LEASING": <PrintLeasingLinks {...props} />,
                "HOLD_LT": <PrintLTLinks {...props}  />,
                "PTS_P2P": <PrintP2PLinks {...props}  />,
                "HOLD": <PrintLinks {...props}  />,
                "PTS": <PrintLinks {...props}  />
            })[props.programType]
        }
        </div>
    </Paper>
);



// WEBPACK FOOTER //
// ./src/components/PrintContract.js